import React, { useContext } from 'react'
import { TrajectoryConfigurationContext } from '../../TrajectoryConfigurationContext'
import Canvas from './Canvas'

const PolygonCreator3000 = () => {
    const trajectoryConfigurationContext = useContext(TrajectoryConfigurationContext)

    return (
        <div>
            <Canvas polygon={trajectoryConfigurationContext.dataDB.polygonData || null}></Canvas>
        </div>
    )
}

export default PolygonCreator3000
